import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
	providedIn: 'root',
})
export class CookiesService {
	constructor(private readonly cookieService: CookieService) {}

	private _resolveCookieDomain(): string {
		const currentDomain = globalThis.location.hostname;
		if (currentDomain.includes('localhost')) return 'localhost';
		if (currentDomain.includes('sumax.pe')) return '.sumax.pe';
		return '.sintad.net.pe';
	}

	setItem(key: string, value: string): void {
		const domain = this._resolveCookieDomain();
		this.cookieService.set(key, value, undefined, '/', domain, true);
	}

	getItem(key: string): string {
		return this.cookieService.get(key);
	}

	removeItem(key: string): void {
		const domain = this._resolveCookieDomain();
		this.cookieService.delete(key, '/', domain, true);
	}

	checkItem(key: string): boolean {
		return this.cookieService.check(key);
	}

	getBearerAuthorization(key: 'idToken' | 'maestroSyncToken'): string {
		const userToken = this.getItem(environment[key]);
		const bearer = 'Bearer ' + userToken;
		return bearer;
	}
}
